import React, { createContext, useState } from "react";

export const ForecastContext = createContext();

export const ForecastProvider = ({ children }) => {
    const [loadForecastData, setLoadForecastData] = useState(null);
    const [priceForecastData, setPriceForecastData] = useState(null);
    const [solarForecastData, setSolarForecastData] = useState(null);
    const [windForecastData, setWindForecastData] = useState(null);

    return (
        <ForecastContext.Provider value={{
            loadForecastData, setLoadForecastData,
            priceForecastData, setPriceForecastData,
            solarForecastData, setSolarForecastData,
            windForecastData, setWindForecastData
        }}>
            {children}
        </ForecastContext.Provider>
    );
};
